import React from "react";
import Main from "./components/Main";
var QuotesComponent = function (_a) {
    var className = _a.className, env = _a.env, allowScroll = _a.allowScroll, isDemo = _a.isDemo, reset = _a.reset, applicationId = _a.applicationId, hideChat = _a.hideChat, coverdashBackButton = _a.coverdashBackButton, license = _a.license, autoResize = _a.autoResize, source = _a.source;
    return (React.createElement(React.Fragment, null,
        React.createElement(Main, { className: className, env: env, allowScroll: allowScroll, isDemo: isDemo, reset: reset, applicationId: applicationId, coverdashBackButton: coverdashBackButton, hideChat: hideChat, license: license, autoResize: autoResize, source: source })));
};
export default QuotesComponent;
